module.exports = __webpack_public_path__ + "static/media/field-sunny@2x.45960d80.png";